module.exports = __webpack_public_path__ + "img/alert-bg-old.ea28ed3d.png";